const endpoint = property => `/api/${property}/basket`;

export default ['api', function (api) {
    return {
        generateBasket: () => {
            return api.get(endpoint(api.property())).then(response => response.data);
        },
        retrieveBasket: basketCode => {
            return api.get(`${endpoint(api.property())}/${basketCode}?items=true`).then(response => response.data);
        },
        submitBasket: basket => {
            return api.post(endpoint(api.property()), basket).then(response => response.data);
        },
        deleteBasket: (basketCode) => {
            return api.delete(`${endpoint(api.property())}/${basketCode}`).then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/services/basket.api.service.js